import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, fmtErr } from "../lib/api";
import RulesEngine from "../components/RulesEngine";
import { Scroll } from "@phosphor-icons/react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { toast } from "sonner";

export default function ClientRules() {
  const [clients, setClients] = useState([]);
  const [params, setParams] = useSearchParams();
  const clientId = params.get("client") || "";

  useEffect(() => {
    api.get("/clients").then(({ data }) => {
      const list = Array.isArray(data) ? data : data.clients || [];
      setClients(list);
      if (!clientId && list.length) setParams({ ...Object.fromEntries(params), client: String(list[0].id || list[0]._id) }, { replace: true });
    }).catch((e) => toast.error(fmtErr(e)));
  }, []); // eslint-disable-line

  const client = clients.find((c) => String(c.id || c._id) === clientId);

  return (
    <div className="p-6 space-y-4" data-testid="client-rules-page">
      <div className="flex items-center gap-4 flex-wrap">
        <div className="w-10 h-10 bg-[var(--c-accent)]/15 border border-[var(--c-accent)]/40 rounded-sm flex items-center justify-center shrink-0">
          <Scroll size={20} className="text-[var(--c-accent)]" />
        </div>
        <div className="flex-1 min-w-52">
          <h1 className="text-2xl tracking-tight font-medium text-[var(--c-text)]" data-testid="client-rules-title">Client Rules</h1>
          <p className="text-xs text-[var(--c-muted)] mt-0.5">
            Per-client validation rules engine — rules auto-check incoming specs and outgoing deliverables. Upload a client spec sheet to extract rules with AI, then review &amp; accept.
          </p>
        </div>
        <Select value={clientId} onValueChange={(v) => setParams({ ...Object.fromEntries(params), client: v })}>
          <SelectTrigger data-testid="client-rules-client-select" className="w-64 h-9 bg-[var(--c-surface)] border-[var(--c-border)] text-[var(--c-text)] text-xs">
            <SelectValue placeholder="Select client" />
          </SelectTrigger>
          <SelectContent className="bg-[var(--c-surface)] border-[var(--c-border)]">
            {clients.map((c) => (
              <SelectItem key={c.id || c._id} value={String(c.id || c._id)} className="text-[var(--c-text)] focus:bg-[var(--c-surface-2)]">{c.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {client ? (
        <RulesEngine key={clientId} clientId={clientId} clientName={client.name} />
      ) : (
        <div className="bg-[var(--c-surface)] border border-[var(--c-border)] rounded-lg shadow-sm p-10 text-center text-sm text-[var(--c-muted)]" data-testid="client-rules-empty">
          {clients.length === 0 ? "No clients yet — add one from the Clients page first." : "Select a client to manage rules."}
        </div>
      )}
    </div>
  );
}
